import React from 'react';
import { useField, FieldHookConfig } from 'formik';
import { TextField, TextFieldProps } from '@bw/foundry';

const FormikTextField = ({ helperText, ...props }: TextFieldProps) => {
  const [field, meta] = useField(props as FieldHookConfig<TextFieldProps>);
  const hasError = !!meta.error && meta.touched;
  return (
    <TextField
      {...field}
      error={hasError}
      helperText={hasError ? meta.error : helperText}
      {...props}
    />
  );
};

export default FormikTextField;
